export const isServer = typeof window === 'undefined';
export const isBrowser = !isServer;
export const isProdEnv = process.env.ENV_NAME === 'production';
export const isDevEnv = process.env.ENV_NAME === 'development';
export const isTestEnv = process.env.ENV_NAME === 'test';
